import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import CookieSettingsModal from '../cookies/CookieSettingsModal';
import '../../styles/components/common/Footer.css';

const Footer = () => {
  const [isCookieModalOpen, setCookieModalOpen] = useState(false);

  const openCookieSettings = () => {
    setCookieModalOpen(true);
  };

  const closeCookieSettings = () => {
    setCookieModalOpen(false);
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "WeiFinders",
    "url": "https://weifinders.com",
    "logo": "https://weifinders.com/weifinders_logo.svg",
    "sameAs": [
      "https://www.youtube.com/@WeiFinders",
      "https://www.instagram.com/WeiFinders/"
    ]
  };

  return (
    <footer className="footer" role="contentinfo">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>
      <nav className="footer-nav" aria-label="Footer Navigation">
        <ul className="footer-links">
          <li><a href="/about">About Us</a></li>
          <li><a href="/contact">Contact Us</a></li>
          <li><a href="/privacy-policy">Privacy Policy</a></li>
          <li><a href="/terms-of-service">Terms of Service</a></li>
          <li>
            <button
              className="cookie-settings-button"
              onClick={openCookieSettings}
              aria-label="Update cookie preferences"
            >
              Cookie Settings
            </button>
          </li>
        </ul>
      </nav>
      <nav className="social-nav" aria-label="Social Media">
        <ul className="social-media">
          <li>
            <a href="https://www.youtube.com/@WeiFinders" target="_blank" rel="noopener noreferrer">
              YouTube
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/WeiFinders/" target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          </li>
        </ul>
      </nav>
      <div className="footer-copy">&copy; 2025 WeiFinders</div>
      <CookieSettingsModal isOpen={isCookieModalOpen} onRequestClose={closeCookieSettings} />
    </footer>
  );
};

export default Footer;
